import { Component, OnInit, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import { ButtonAction } from 'src/app/asset/models/action-button.model';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { DeleteAasetComponent } from 'src/app/shared/components/assets-container/delete-aaset/delete-aaset.component';
import { SentToTenantAssetComponent } from 'src/app/shared/components/assets-container/sent-to-tenant-asset/sent-to-tenant-asset.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AssetModel } from 'src/app/property/models/new-asset.model';
import { BottomConfirmationMessageComponent } from 'src/app/shared/components/bottom-confirmation-message/bottom-confirmation-message.component';
import { TenantTypes } from 'src/app/property/models/property-activity.model';
import { SendTenatToAssetLinkEmail } from 'src/app/shared/models/assets-register/send-tenat-asset-link-email.model';
import { MatDrawer } from '@angular/material/sidenav';
import { JobAssetService } from 'src/app/core/services/http/maintenance/job-asset.service';
import { AssetStatusCategories } from 'src/app/asset/models/asset.model';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent implements OnInit {
  isLoading = false;
  @Output() buttonClicked = new EventEmitter<ButtonAction>();
  @Input() isShowSendToTenant: boolean;
  @Input() asset : AssetModel;
  @Input() assetStatus: string;
  

  sendTenatToAssetLinkEmail = new SendTenatToAssetLinkEmail();
  private _organizationId: string;
  assetStatusCategories = AssetStatusCategories;
  @ViewChild('drawer') drawer!: MatDrawer;
  
  constructor(private assetService: AssetService, 
    private toaster: TosterService,
    private bottomSheet: MatBottomSheet,
    private jobAssetService: JobAssetService) {
   }

  ngOnInit(): void {
    if(!this.asset.isVacantProperty)
      this.getTenantType(this.asset.id);       
  }

  edit() {
    this.buttonClicked.emit(ButtonAction.Edit)
  }

  approve() {
    this.isLoading = true;
    this.assetService.approveAsset(this.asset.id).subscribe({
      next: (res) => {
        if (res) {
          this.isLoading = false;
          this.toaster.success('Asset added successfully to the Property');
        }
      }
    })
  }

  delete() {
    this.bottomSheet.open(
      DeleteAasetComponent,
      {
        data: {
          propertyId: this.asset.propertyId,
          assetId: this.asset.id,
        },
      }
    );
  }

  sendToTenant(){
    this.bottomSheet.open(
      SentToTenantAssetComponent,
      {
        data: {
          assetId: this.asset.id
        },
      }
    );
  }
  public sendSRequestTenantsToUploadAssets: SendLinkTenant = {
    name: 'All',
    completed: false,
    value: 'all',
    parties: [
      { name: 'Primary Tenants', completed: false, value: TenantTypes.PrimaryTenant.toString() },
      { name: 'Secondary Tenants ', completed: false, value: TenantTypes.SecondaryTenant.toString() },
    ],
  };
  allTenantsComplete: boolean = false;
  private getSelectedTenantInvitationType(): TenantTypes {
    if (this.allTenantsComplete) {
      return TenantTypes.All;
    }
    const selectedParties = this.sendSRequestTenantsToUploadAssets.parties.filter(party => party.completed);
    if (selectedParties.length === 1) {
      return selectedParties[0].value === TenantTypes.PrimaryTenant.toString() ? TenantTypes.PrimaryTenant : TenantTypes.SecondaryTenant;
    }
    return TenantTypes.All;
  }
  sendEmailToTenant() {
    var tenantType = this.getSelectedTenantInvitationType();
    this.sendTenatToAssetLinkEmail.propertyId = this.asset.propertyId;
    this.sendTenatToAssetLinkEmail.tenantInvitationType = tenantType;
    this.sendTenatToAssetLinkEmail.assetId = this.asset.id;
    this.assetService.sendTenatToAssetLink(this.sendTenatToAssetLinkEmail).subscribe({
      next: (result) => {
        this.toaster.success("successfully send!");
      },
      error: (error) => {
        console.error('Error sending email:', error);
      }
    });
  }

  inviteTenat() {
    const bottomSheetRef = this.bottomSheet.open(
      BottomConfirmationMessageComponent,
      {
        data: {
          message: "Click proceed to send an email to the tenants requesting to upload the property's assets details.",
          isInviteTenant: true
        },
      });
  
      bottomSheetRef.afterDismissed().subscribe((result) => {
        if (result === true) {
          this.sendEmailToTenant() //todo
        } 
      });
      this.closeDrawer();
    }

    isAnyTenantSelected(): boolean {
      return this.sendSRequestTenantsToUploadAssets.parties.some(party => party.completed);
    }

    closeDrawer(): void {
      this.drawer.close();
    }
    updateAllCompleteSendLink() {
      this.allTenantsComplete =
        this.sendSRequestTenantsToUploadAssets.parties != null &&
        this.sendSRequestTenantsToUploadAssets.parties.every((t) => t.completed);
    }

    setAllSendLink(completed: boolean) {
      this.allTenantsComplete = completed;
      if (this.sendSRequestTenantsToUploadAssets.parties == null) {
        return;
      }
      this.sendSRequestTenantsToUploadAssets.parties.forEach((t) => (t.completed = completed));
    }

    someCompleteSendLink(): boolean {
 
      if (this.sendSRequestTenantsToUploadAssets.parties == null) {
        return false;
      }
      return (
        this.sendSRequestTenantsToUploadAssets.parties.filter((t) => t.completed).length > 0 &&
        !this.allTenantsComplete
      );
    }

    openDrawer(assetId: string): void {
      this.resetCheckboxes();
      if(!this.asset.isVacantProperty)
      this.getTenantType(assetId) 
      
      this.drawer.open();
    }
    resetCheckboxes() {
      this.sendSRequestTenantsToUploadAssets.parties.forEach(party => {
        party.completed = false;
      });
    }

    getTenantType(assetId: string) {
      this.assetService.getTenantType(assetId).subscribe({
        next: (res) => {
          this.sendTenatToAssetLinkEmail.tenantInvitationType = res.tenantInvitationType;
          this.sendTenatToAssetLinkEmail.isAIGenerated = res.isAIGenerated;
          this.updateCheckboxes(res.isAIGenerated);
        }
      });
    }
    
    updateCheckboxes(isAiGenerated: boolean) {
      if (!this.sendSRequestTenantsToUploadAssets.parties) return;
      if (isAiGenerated) {
        this.sendSRequestTenantsToUploadAssets.parties.forEach(party => {
          party.enabled = true;    
          party.completed = false;
        });
      } 
      else {
        const selectedTenantType = this.sendTenatToAssetLinkEmail.tenantInvitationType.toString();
    
        this.sendSRequestTenantsToUploadAssets.parties.forEach(party => {
          if (party.value === selectedTenantType) {
            party.enabled = true;    
            party.completed = true;  
          } else {
            party.enabled = false;   
            party.completed = false; 
          }
        });
      }
      this.updateAllCompleteSendLink();
    }
    
}
export interface Task {
  name: string;
  value: string;
  completed: boolean;
  parties?: Task[];
}

export interface SendLinkTenant {
  name: string;
  value: string;
  completed: boolean;
  parties?: TenantSubtask[];
}

interface TenantSubtask {
  name: string;
  completed: boolean;
  value: string;
  enabled?: boolean;
}
